import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useSite } from '../context/SiteContext';

const SiteHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { currentSite } = useSite();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Accueil', href: '/' },
    { label: 'Master Plan', href: '/#masterplan' },
    { label: 'Le Parcours', href: '/#parcours' },
    { label: 'Lifestyle', href: '/#lifestyle' }
  ];

  const scrollToSection = (href) => {
    if (href.startsWith('/#')) {
      const sectionId = href.replace('/#', '');
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#0f2419]/95 backdrop-blur-md py-4'
          : 'bg-transparent py-6'
      }`}
    >
      {/* Top Gold Line */}
      <div className={`absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a962]/50 to-transparent transition-opacity ${
        isScrolled ? 'opacity-100' : 'opacity-0'
      }`} />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-4 group">
            <div className="w-12 h-12 border-2 border-[#c9a962] flex items-center justify-center transition-all duration-300 group-hover:bg-[#c9a962]">
              <span className="font-playfair font-bold text-lg text-[#c9a962] group-hover:text-[#0f2419] transition-colors">
                LGS
              </span>
            </div>
            <div className="hidden sm:flex flex-col">
              <span className="font-playfair text-lg text-white">
                Le Golf de Songon M'braté
              </span>
              <span className="font-montserrat text-[10px] tracking-[0.2em] uppercase text-[#c9a962]">
                Prestige & Excellence
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => scrollToSection(link.href)}
                className="font-montserrat text-sm tracking-wide transition-colors duration-300 text-white/70 hover:text-[#c9a962]"
              >
                {link.label}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <button 
              onClick={() => scrollToSection('/#contact')}
              className="btn-gold px-6 py-3 text-xs uppercase tracking-widest"
            >
              Nous contacter
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="text-white" size={24} />
            ) : (
              <Menu className="text-white" size={24} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-6 pb-6 border-t border-[#c9a962]/20">
            <nav className="flex flex-col gap-4 pt-6">
              {navLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollToSection(link.href)}
                  className="font-montserrat text-sm text-white/80 hover:text-[#c9a962] transition-colors text-left"
                >
                  {link.label}
                </button>
              ))}
              <button 
                onClick={() => scrollToSection('/#contact')}
                className="btn-gold mt-4 text-center py-3 text-xs uppercase tracking-widest"
              >
                Nous contacter
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default SiteHeader;
